const designRouter = [
  {
    path: '/design',
    name: 'design',
    component: () => import('@/views/sidebar/designOnline'),
    meta: {
      title: '设计在线'
    },
    children: [
      // =====================yuehui=========================
      {
        path: 'home',
        name: 'design-home',
        component: () => import('@/views/sidebar/designOnline/rad-staff'),
        meta: {
          title: '设计在线'
        }
      },
      {
        path: 'create',
        name: 'delivery-create',
        component: () => import('@/views/sidebar/designOnline/rad-staff/assessment/create'),
        meta: {
          title: '创建评测'
        }
      },
      {
        path: 'info',
        name: 'delivery-info',
        component: () => import('@/views/sidebar/designOnline/rad-staff/assessment/info'),
        meta: {
          title: '创建评测'
        }
      },
      // =====================shiqiong=========================
      {
        path: 'index',
        name: 'designIndex',
        component: () => import('@/views/sidebar/designOnline/rad-customer/index'),
        meta: {
          title: '需求评测'
        }
      },
      {
        path: 'openEvaluating',
        name: 'openEvaluating',
        component: () => import('@/views/sidebar/designOnline/rad-customer/openEvaluating'),
        meta: {
          title: '需求评测'
        }
      },
      {
        path: 'evaluatingHouse',
        name: 'evaluatingHouse',
        component: () => import('@/views/sidebar/designOnline/rad-customer/evaluatingHouse'),
        meta: {
          title: '需求评测'
        }
      },
      {
        path: 'endEvaluating',
        name: 'endEvaluating',
        component: () => import('@/views/sidebar/designOnline/rad-customer/endEvaluating'),
        meta: {
          title: '需求评测'
        }
      },
      // =====================jinfeng=========================
      {
        path: 'styleLibrary/:wxFlockId',
        name: 'styleLibrary',
        component: () => import('@/views/sidebar/designOnline/solutionLibrary/styleLibrary'),
        meta: {
          title: '风格设计方案库'
        },
        props: true
      },
      {
        path: 'spaceLibrary/:wxFlockId',
        name: 'spaceLibrary',
        component: () => import('@/views/sidebar/designOnline/solutionLibrary/spaceLibrary'),
        meta: {
          title: '空间设计方案库'
        },
        props: true
      },
      {
        path: 'spaceSchemeLibrary/:spaceId/:wxFlockId',
        name: 'spaceProgramLibrary',
        component: () => import('@/views/sidebar/designOnline/solutionLibrary/spaceLibrary/scheme'),
        meta: {
          title: '空间设计方案库'
        },
        props: true
      },
      {
        path: 'spaceSchemeContent/:spaceProgramId/:wxFlockId',
        name: 'spaceSchemeContent',
        component: () => import('@/views/sidebar/designOnline/solutionLibrary/spaceLibrary/content.vue'),
        meta: {
          title: '方案参考库'
        },
        props: true
      },
      {
        path: 'styleSchemeContent/:styleProgramId/:wxFlockId',
        name: 'styleSchemeContent',
        component: () => import('@/views/sidebar/designOnline/solutionLibrary/styleLibrary/content.vue'),
        meta: {
          title: '方案参考库'
        },
        props: true
      },
      {
        path: 'measureOnline',
        name: 'measureOnline',
        component: () => import('@/views/sidebar/designOnline/measure-online'),
        meta: {
          title: '在线勘测'
        },
        props: true
      }
    ]
  }
]
export default designRouter

